import React from "react";

function MiscPageMidSection(props) {
  return (
    <div className="container" style={{ marginTop: "6rem" }}>
      <div className="text-center">
        <p className="display-6 fs-4">{props.description}</p>
      </div>
    </div>
  );
}

export default MiscPageMidSection;
